function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 42,
  rx: 5,
  fill: "#ff7e00"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.086 14.871)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.3,0H2A2,2,0,0,0,0,2V19.3a2,2,0,0,0,2,2H19.3a2,2,0,0,0,2-2V2A2,2,0,0,0,19.3,0Zm.666,19.3a.666.666,0,0,1-.666.666H2a.666.666,0,0,1-.666-.666V2A.666.666,0,0,1,2,1.331H19.3A.666.666,0,0,1,19.969,2Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.338,241.665a.666.666,0,0,0-.939,0L88.869,243.2l-2.856-2.856a.666.666,0,0,0-.939,0L80.415,245a.666.666,0,0,0,.466,1.132H94.194a.666.666,0,0,0,.473-1.138Z",
  transform: "translate(-76.887 -230.156)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.037,
  cy: 1.782,
  rx: 2.037,
  ry: 1.782,
  transform: "translate(10.65 5.514)",
  fill: "#fff"
}));

var SvgImageIcon = function SvgImageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image_icon.12927757.svg";
export { ForwardRef as ReactComponent };